var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message)?_c('div',{staticClass:"cart-shipping-offers"},[_c('Icons',{staticClass:"shipping-icon",attrs:{"name":((_vm.isFreeShipping ? '' : 'no-') + "free-shipping")}}),_vm._v("\n\n  "+_vm._s(_vm.message)+"\n")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }